import { Col, DatePicker } from "antd";
import moment from "moment";

import { IDocumentExpirationField } from "./IDocumentExpirationField";

const DocumentExpirationField = ({
	documentExpiration,
	translations,
	errors,
	fieldName,
	index = 0,
	handleDatePicker,
	disabled = false,
}: IDocumentExpirationField) => (
	<Col xs={24} md={6} lg={6} className="titles">
		<label className="required"> {translations.expirationDate}</label>
		<DatePicker
			allowClear={false}
			className="input-field"
			name={fieldName}
			value={documentExpiration ? moment(documentExpiration) : undefined}
			format="DD/MM/YYYY"
			disabled={disabled}
			onChange={ handleDatePicker(fieldName, index) }
			status={errors[index].documentExpiration || errors[index].notValidExpirationDate ? 'error' : ''}
		/>
		<span className={`error ${errors[index].documentExpiration ? 'show' : null}`}>{translations.completeCampo}</span>
		<span className={`error ${errors[index].notValidExpirationDate ? 'show' : null}`}>{translations.invalidDate}</span>
	</Col>
);

export default DocumentExpirationField;
